export const insertInicisModule = () => {
  return new Promise<void>((resolve, reject) => {
    // 이미 로딩된 경우
    // @ts-ignore-next-line
    if (window?.INIStdPay) return resolve();

    // 중복 방지
    if (document.getElementById("inicisScript")) return resolve();

    const inicisScript = document.createElement("script");
    const inicisCloseScript = document.createElement("script");

    const isProd = window.location.hostname === "cloudportal.fasoo.com";
    inicisScript.src = isProd
      ? "https://stdpay.inicis.com/stdjs/INIStdPay.js"
      : "https://stgstdpay.inicis.com/stdjs/INIStdPay.js";
    inicisCloseScript.src = isProd
      ? "https://stdpay.inicis.com/stdjs/INIStdPay_close.js"
      : "https://stgstdpay.inicis.com/stdjs/INIStdPay_close.js";

    inicisScript.id = "inicisScript";
    inicisCloseScript.id = "inicisCloseScript";
    inicisScript.async = true;
    inicisCloseScript.async = true;

    inicisScript.onload = () => {
      console.log("[INIStdPay] 스크립트 로드 완료");
      resolve();
    };

    inicisScript.onerror = () => {
      console.error("[INIStdPay] 스크립트 로드 실패");
      reject(new Error("INIStdPay.js 로딩 실패"));
    };

    document.head.appendChild(inicisScript);
    document.head.appendChild(inicisCloseScript);
  });
};
